import { useEffect, useState, useCallback } from "react";
import axiosInstance from "../api/axiosInstance";
import Orders from "../components/Orders";
import { ORDER_STATUS } from "../constants/orderStatuses";

const FINALIZED_ORDER_STATUSES = [ORDER_STATUS.COMPLETED];

export default function OrdersPage() {
  const [orders, setOrders] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(false);

  const [currentPage, setCurrentPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);

  const fetchOrders = useCallback(async (searchTerm = "", searchType = "", page = 1) => {
    const trimmedSearchTerm = searchTerm.trim();
    setLoading(true);
    setError(false);
    try {
      const params = {
        page: page
      };
      if (trimmedSearchTerm) {
        params.type = searchType; // يرسل نوع الحقل: name أو phone أو location
        params.term = trimmedSearchTerm; // يرسل الكلمة المراد البحث عنها
      }
      const res = await axiosInstance.get(
        `/orders`,
        { params: params }
      );
      const fetchedOrders = res.data.orders || [];
      const visibleOrders = trimmedSearchTerm
        ? fetchedOrders
        : fetchedOrders.filter((order) => !FINALIZED_ORDER_STATUSES.includes(order.status));

      setOrders(visibleOrders); 
      setTotalPages(res.data.totalPages || 1); 
      setCurrentPage(page);
    } catch (err) {
      setError(true);
      console.error("حدث خطأ أثناء جلب الطلبات:", err);
    } finally {
      setLoading(false);
    }
  },[]);

  const deleteOrder = async (id) => {
    const confirmDelete = window.confirm("هل أنت متأكد من حذف هذه الطلبية؟");
    if (!confirmDelete) return;

    try {
      await axiosInstance.delete(
        `/orders/${id}`
      );
      fetchOrders();
    } catch (err) {
      console.error("حدث خطأ أثناء حذف الطلب:", err);
    }
  };

  useEffect(() => {
    fetchOrders();
  }, [fetchOrders]);

  return (
    <Orders
      orders={orders}
      loading={loading}
      error={error}
      onDelete={deleteOrder}
      onSearch={fetchOrders}
      currentPage={currentPage}
      totalPages={totalPages}
    />
  );
}
